import React, { Component } from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import WhyDesignMatters from 'views/whyDesignMatters';
import Layout from 'components/layout';
import { NavBar } from 'components';
import { pages } from 'config/pages';
import config from '../../../meta/config';

class WDMPage extends Component {
  render() {
    const page = pages.work.items['why-design-matters'];
    const { navColors } = page;
    const canonical = `${config.siteUrl}/work/why-design-matters/`;

    const { data } = this.props;
    const { allArticles } = data || {};

    return (
      <Layout {...{page, canonical}}>
        <Helmet title="Why Design Matters">
          <meta
            name={'title'}
            content={'UX and UI Design Services | User Experience Consulting'}
          />
          <meta
            name={'description'}
            content={
              'When you’re building digital products, good design is important. Read our article about UX & UI design to find 5 reasons why really design matters'
            }
          />
          <link rel="canonical" href={canonical} />
        </Helmet>
        <NavBar color={navColors} />
        <WhyDesignMatters allArticles={allArticles} />
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query WDMPage {
    allArticles: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___settings___date] }
      filter: {
        frontmatter: {
          title: {
            in: [
              "Visualising Energy"
              "How to scale a monolithic MVP application without losing business?"
              "From design to development in 4 weeks. Creating a mobile and web MVP for an iconic brand"
            ]
          }
        }
      }
    ) {
      ...markdownFields
      ...boxMarkdownFields
    }
  }
`;

export default WDMPage;
